import { render, staticRenderFns } from "./MaidClaimPosted.vue?vue&type=template&id=0bb0d235&"
import script from "./MaidClaimPosted.vue?vue&type=script&lang=js&"
export * from "./MaidClaimPosted.vue?vue&type=script&lang=js&"
import style0 from "./MaidClaimPosted.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MaidClaimPosted.vue"
export default component.exports